<template>
  <div>
    <MasterLayout>
      <div class="section__row mt-3">
      <div>
        <b-modal
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.iAddOrder.confirmingPayment')"
          v-if="status == loading"
        >
          <div class="epump-loader" style="top: 22%;left: 35%; width:120px; height: 120px">
            <img src="@/assets/img/epump-logo.png" class="epump-loader-logo" />
          </div>
        </b-modal>
        <b-modal
          v-if="status == success"
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.iAddOrder.paymentConfirmed')"
        >
          <div style="margin:0 auto; width: 43%; margin-top: 80px" class>
            <div class="success-checkmark">
              <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
              </div>
            </div>
          </div>
        </b-modal>
        <b-modal
          v-if="status == failure"
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.iAddOrder.errorConfirming')"
        >
          <div style="margin:0 auto; width: 43%">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 130.2 130.2"
              class="cancel_img"
            >
              <circle
                class="path circle"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-miterlimit="10"
                cx="65.1"
                cy="65.1"
                r="62.1"
              />
              <line
                class="path line"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="34.4"
                y1="37.9"
                x2="95.8"
                y2="92.3"
              />
              <line
                class="path line"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="95.8"
                y1="38"
                x2="34.4"
                y2="92.2"
              />
            </svg>
          </div>
        </b-modal>
      </div>
      </div>
      <section class=" mt-3 full__row_section">
          <div class="row">
              <div class="col-md-12">
                   <div class="dashboard__card large_card card_padding indus_back_img_lg">
                        <div class="row make-row-hundred-percent align-items-center justify-content-center" >
                            <div class="col-md-12">
                                <div class="progress_container">
                                    <div class="order_steps__container">
                                        <div class="order_steps__inner_wrapper">
                                            <div class="order_progress_step active_outer_circle" >
                                                <div class="order_progress_step_inner_cirle ">
                                                     <div class="order_progress_step_inner_cirle active_inner" >
                                                
                                                    </div>
                                                </div>
                                            </div>
                                            <h6 class="text-white mt-3">{{$t('text.iAddOrder.order')}}</h6>
                                        </div>
                                          <div class="order_steps__inner_wrapper">
                                            <div class="order_progress_step" ref="shipping_step" > 
                                                <div class="order_progress_step_inner_cirle" ref="shipping_inner_step" >
                                                
                                                </div>
                                            </div>
                                            <h6 class="text-white mt-3">{{$t('text.iAddOrder.shipping')}}</h6>
                                        </div>
                                        <div class="order_steps__inner_wrapper">
                                            <div class="order_progress_step" ref="paymentStep"> 
                                                <div class="order_progress_step_inner_cirle" ref="payment_inner_step"  >
                                                
                                                </div>
                                            </div>
                                            <h6 class="text-white mt-3">{{$t('text.iAddOrder.payment')}}</h6>
                                        </div>
                                    </div>
                                    <div class="progress_track_1"></div>
                                    <div class="progress_track_2"></div>
                                </div>
                            </div>
                        </div>
                    </div>
              </div>
          </div>
      </section>
      <section class="full__row_section mt-3 pb-3">
          <div class="m_wrapper">
              <div class="form_wrapper" v-if="viewStatus === 'order'">
                  <div class="text-center">
                      <img src="@/assets/img/transportation.svg"  width="100px"/>
                  </div>
                  <div class="row mt-4 justify-content-center align-items-center">
                      <div class="col-md-3">
                          <label>{{$t('text.iAddOrder.fullAddress')}}</label>
                      </div>
                      <div class="col-md-9">
                          <div class="input__block input_width_shrink" style="height: 87px">
                            <textarea  type="text" rows="3"  readonly v-model="branchAddress"  class="form-control input_full_width"  ></textarea>
                        </div>
                      </div>
                  </div>
                   <div class="row  mt-5 justify-content-center align-items-center">
                      <div class="col-md-3">
                          <label>{{$t('text.iAddOrder.station')}}</label>
                      </div>
                      <div class="col-md-9">
                        <div class="input__block input_width_shrink" >
                             <input  type="text" rows="3"  readonly v-model="industryBranchnName"  class="form-control input_full_width"  />
                        </div>
                      </div>
                  </div>
                  <div class="row  mt-5 justify-content-center align-items-center">
                      <div class="col-md-3">
                          <label>{{$t('text.iAddOrder.volume')}}({{$t('text.iAddOrder.litres')}})</label>
                      </div>
                      <div class="col-md-9">
                        <div class="input__block input_width_shrink" >
                            <input  type="number" v-model="orderDetails.quantity" readonly  :placeholder="$t('text.iAddOrder.volume')"  class="form-control input_full_width"  />
                        </div>
                      </div>
                  </div>
                  <div class="row  mt-5 justify-content-center align-items-center">
                      <div class="col-md-3">
                          <label>{{$t('text.iAddOrder.product')}}</label>
                      </div>
                      <div class="col-md-9">
                        <div class="input__block input_width_shrink" >
                            <select v-model="orderDetails.productId" @change="prodChange" >
                                <option value="select product" disabled>{{$t('text.iAddOrder.selectAProduct')}}</option>
                                <option :value="prod.productId" readonly v-for="(prod,i) in products" :key="i">{{prod.productName}}</option>
                            </select>
                        </div>
                      </div>
                  </div>
                   
                    <div class="row  mt-5 justify-content-center align-items-center">
                      <div class="col-md-3"> </div>
                      <div class="col-md-9">
                         <div class="text-center mt-4">
                            <button class="vue_router_link btn btn_theme" @click="changeProgrestatus('shipping', 'order')">
                               {{$t('text.iAddOrder.next')}}
                            </button>
                        </div>
                      </div>
                  </div>
                 
              </div>
               <div class="form_wrapper text-left" v-if="viewStatus === 'shipping'">
                 <div class="form_container__wrapper">
                    <div class="text-center">
                      <img src="@/assets/img/transportation.svg"  width="100px"/>
                  </div>
                  <div class="row mt-4 justify-content-center align-items-center">
                     <div class="col-md-6">
                          <small class="text-black">{{$tc('text.iAddOrder.pricePerLitre', 1)}}</small>
                      </div>
                      <div class="col-md-6 text-right">
                        <label>{{orderDetails.price}}</label>
                      </div>
                  </div>
                   <div class="row  mt-4 justify-content-center align-items-center">
                      <div class="col-md-6">
                          <small class="text-black">{{$t('text.iAddOrder.amount')}}</small>
                      </div>
                      <div class="col-md-6 text-right">
                        <label>
                        <!-- {{ $n(orderDetails.amount, 'currency') }} -->
                         {{industryBranch ?  industryBranch.currencyCode : ''}}
                          {{convertThousand(orderDetails.amount)}}
                        </label>
                      </div>
                  </div>
                   <div class="row  mt-4 justify-content-center align-items-center">
                      <div class="col-md-6">
                          <small class="text-black">{{$t('text.iAddOrder.litreVolume')}}</small>
                      </div>
                      <div class="col-md-6  text-right">
                        <label>{{orderDetails.quantity}} {{$t('text.iAddOrder.litres')}}</label>
                      </div>
                  </div>
                   <div class="row  mt-4 justify-content-center align-items-center">
                      <div class="col-md-6">
                          <small class="text-black">{{$t('text.iAddOrder.deliveryAddress')}}</small>
                      </div>
                      <div class="col-md-6 text-right">
                        <label>{{branchAddress}}</label>
                      </div>
                  </div>
                    <div class="row  mt-5 justify-content-center align-items-center">
                      <div class="text-center mt-4">
                            <button class="vue_router_link btn btn_theme yellow_text mr-2" @click="changeProgrestatus('order', 'shipping')">
                                {{$t('text.iAddOrder.previous')}}
                            </button>
                            <button class="vue_router_link btn btn_theme" @click="changeProgrestatus('payment')">
                                {{$t('text.iAddOrder.next')}}
                            </button>
                        </div>
                  </div>
                 </div>
              </div>
               <div class="center_div" v-if="viewStatus === 'payment'" style="margin-top:0px">
                  <div class="pad_div">
                    <ul class="tabs__lists">
                      
                      <li class="mt-3 mr-4" @click="changeTab('wallet')">
                        <a href="#" class="tab_link" :class="[tab === 'wallet' ?  'active__tab__link' : null]">
                          <i
                            class="fa fa-credit-card mr-2"
                            aria-hidden="true"
                            :style="[tab === 'wallet' ?  {color:'#370F70'} : null]"
                          ></i>
                          {{$t('text.iAddOrder.wallet')}}
                        </a>
                      </li>
                      <li class="mt-3 mr-4" @click="changeTab('card')">
                        <a href="#" class="tab_link" :class="[tab === 'card' ?  'active__tab__link' : null]">
                          <i
                            class="fa fa-credit-card mr-2"
                            aria-hidden="true"
                            :style="[tab === 'card' ?  {color:'#370F70'} : null]"
                          ></i>
                          {{$t('text.iAddOrder.payWithCard')}}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div v-if="tab === 'card'">
                    <div class="pay_header text-center">{{$t('text.iAddOrder.confirmAmount')}}</div>
                    <div class="text-center mt-4">
                      <img src="@/assets/img/credit-card.svg" width="35px" />
                    </div>
                    <div class="text-center mt-4">
                      <small class="small_text"></small>
                    </div>
                    <div class="input_holder">
                      <div class="mt-4">
                        <input type="hidden" class="email" />
                        <input type="hidden" class="phone" />
                        <input type="hidden" class="publicKey" />
                        <input type="hidden" name="trxRef" class="trxRef" />
                        <input type="hidden" name="flwRef" class="flwRef" />
                        <input
                          type="number"
                          name="amount"
                          :value="totalAmount"
                          class="form-control form__input amount"
                          :placeholder="$t('text.iAddOrder.amount')"
                          style="width: 100%"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="mt-4 text-center">
                       <!-- <button class="vue_router_link btn btn_theme yellow_text mr-2" @click="changeProgrestatus('shipping', 'payment')">
                            Previous
                        </button> -->
                      <button class="btn btn_theme" @click="payFunction($event)">{{$t('text.iAddOrder.payNow')}}</button>
                    </div>
                  </div>

                  <div v-if="tab === 'wallet'" >
                    
                
                    <div
                      class="pay_header text-center"
                    >{{$t('text.iAddOrder.walletDebited')}}</div>
                    <div class="text-center mt-4">
                      <img src="@/assets/img/money (3).svg"  width="50" />
                    </div>
                    <div class="fund_wallet_user_details_wrapper" style="width: 64%">
                      <div class="mt-4">
                          <div class="clearfix clearfix_mobile mt-3" style="width: 70%; margin: 0 auto;">
                              <div class="left_div">
                                  <span class="accont_text_span">{{$t('text.iAddOrder.volume')}}:</span>
                              </div>
                              <div class="right_div">
                                  <b class="accont_text_span">{{this.orderDetails.quantity}} {{$t('text.iAddOrder.litres')}}</b>
                              </div>
                          </div>
                      </div>
                      <div class="clearfix clearfix_mobile mt-3" style="width: 70%; margin: 0 auto;">
                          <div class="left_div">
                              <span class="mr-4 accont_text_span">{{$t('text.iAddOrder.amount')}}:</span>
                          </div>
                          <div class="right_div">
                              <b class="accont_text_span">
                              <!-- {{ $n(orderDetails.amount, 'currency') }} -->
                              {{industryBranch ?  industryBranch.currencyCode : ''}}
                              {{convertThousand(this.orderDetails.amount)}}
                              </b>
                          </div>
                      </div>
                      <div class="clearfix clearfix_mobile mt-3" style="width: 70%; margin: 0 auto;">
                          <div class="left_div">
                              <span class="mr-4 accont_text_span">{{$tc('text.iAddOrder.pricePerLitre', 2)}}:</span>
                          </div>
                          <div class="right_div">
                              <b class="accont_text_span">
                              <!-- {{ $n(orderDetails.price, 'currency') }} -->
                               {{industryBranch ?  industryBranch.currencyCode : ''}}
                              {{convertThousand(this.orderDetails.price)}}
                              </b>
                          </div>
                      </div>
                      <div class="mt-5">
                        <!-- <div class="pay_header text-center">Your Wallet would be funded within the next few minutes. </div> -->
                      </div>
                      <div class="mt-4 text-center">
                       <!-- <button class="vue_router_link btn btn_theme yellow_text mr-2" @click="changeProgrestatus('shipping', 'payment')">
                            Previousloader
                        </button> -->
                      <button class="btn btn_theme" @click="walletPayment($event)" 
                        :disabled="isButtonDisabled ? true : false"
                        :style="[
                          isButtonDisabled
                            ? { cursor: 'not-allowed' }
                            : { cursor: 'pointer' }
                        ]"> {{$t('text.iAddOrder.payNow')}}
                        <img
                          src="@/assets/img/git_loader.gif"
                          style="display:none"
                          width="20px"
                          class="ml-3 loader"

                        />
                      </button>
                      
                    </div>
                    </div>
                  </div>

                  
              </div>
          </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from 'vue';
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import {VueApexCharts} from "apexcharts"
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import backgroundUrl from "@/assets/img/MobileWallet.png";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: 'Complete Order:: Epump Industrial Portal',
  name: "DashboardHome",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides, 
    VueperSlide,
  },
   provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport]
  },
  data() {
      return {
        backImg,
        viewStatus: 'payment',
        showLoader: false,
        orderDetails: {},
        branchDetails: localStorage.getItem("totalBranches")
        ? JSON.parse(localStorage.getItem("totalBranches"))
        : null,
        industryBranch: null,
        industryBranchId: null,
        volume: null,
        products: [],
        product: "select product",
        pricePerLiter: null,
        tab: "wallet",
        loading: 0,
        paymentConfirmed: null,
        success: 1,
        failure: 2,
        status: 0,
        backgroundUrl,
        modalWidth: null,
        modalheight: null,
        showBanner: true,
        payOnline: true,
        email: "",
        phone: "",
        publicKey: "",
        banks: null,
        amount: null,
        depositNo: null,
        depositorName: null,
        bank: null,
        showdropDown: false,
        accountName: null,
        accountNumber: null,
        toggleBanksDropdown: false,
        isButtonDisabled: false,
        showButtonLoader: true,
        flwRef: "",
        trxRef: "",
        reservedAccount: null,
        accountName: null,
        bankName: null,
        totalAmount: 0,
      }
  },
  created() {
     this.$eventHub.$on("industryBranch", (industryBranch) => {
        this.industryBranch = industryBranch;
    })
  },
  watch: {
    industryBranch: function (newIndustry, oldIndustry) {
        if(newIndustry.id !== null) {
            this.industryBranchId = newIndustry.id;
        }
    },
  },
  computed: {
    branchAddress() {
      return this.branchDetails[0].street + " " + "," +  this.branchDetails[0].city + " " + "," +  this.branchDetails[0].state + " " +  "," + this.branchDetails[0].country
    },
    industryBranchnName() {
      return this.branchDetails[0].name
    }
  },
 mounted() {
   this.getProducts();
   this.getAccountDetails();
   this.getFundProperties();
   this.getOrderDetails();
    if(screen.width <= 575) {
      document.querySelector('.padding_div').classList.remove('remove-padding-left');
      document.querySelector('.padding_div').style.marginTop  = '15px';
    }
    this.$refs.shipping_step.classList.add('active_outer_circle');
    this.$refs.shipping_inner_step.classList.add('active_inner');
 },
 methods : {
    getAccountDetails() {
      this.showBtnLoader = true;
      if (localStorage.getItem("userDetails")) {
        let url = `${configObject.apiBaseUrl}/Wallet/Balance`;
        this.axios
          .get(url, configObject.authConfig())
          .then(response => {
            this.reservedAccount = response.data.reservedAccount;
            this.accountName = response.data.accountName;
            this.bankName = response.data.bankName;
          })
          .catch(error => {});
      }
    },
    getOrderDetails() {
        this.showLoader = true;
        this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/Order/${this.$route.query.id}`,
          configObject.authConfig()
        )
        .then(response => {
          this.orderDetails = response.data;
          console.log(this.orderDetails)
          this.orderDetails.date = this.$moment(response.data.date).format("MMMM D, YYYY");
          this.orderDetails.modifiedDate = this.$moment(response.data.modifiedDate).format("h:mm A");
          this.totalAmount = response.data.amount;
          this.orderDetails.quantity = response.data.quantity
          this.orderDetails.price = response.data.price
        })
        .catch(error => {
            this.showLoader = false
        });
    },
    getOrders() {
        this.showLoader = true;
        this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/Orders/${this.industryBranch.id}`,
          configObject.authConfig()
        )
        .then(res => {
          let index = 0;
          let orderIDs = [];
          res.data.forEach(el => {
            orderIDs.push(el.id);
          })
          const latestOrder = Math.max(...orderIDs);
          this.latestOrderId = latestOrder;
        })
        .catch(error => {
            this.showLoader = false
        });
    },
 
    changeTab(tab) {
      this.tab = tab;
    },
    prodChange(event) {
      let product  = this.products.filter(prod => prod.productId === event.target.value)[0];
      this.pricePerLiter = this.convertThousand(product.price);
    },
    convertThousand(request) {
        if (!isFinite(request)) {
            return "0.00";
        }
        return request.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  
    getProducts() {
        this.showLoader = true;
        this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/peddlingProducts`,
          configObject.authConfig()
        )
        .then(res => {
          this.products = res.data
        })
        .catch(error => {
            this.showLoader = false
        });
    },
    randomString(length, chars) {
      var result = "";
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    },
     showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    generateTransactionRef() {
      var allString = "0123456789";
      var rString = "EP" + this.randomString(14, allString);
      return rString;
    },
    walletPayment($event) {
      $event.preventDefault();
      let tx_ref = this.generateTransactionRef();
       let data = {
        orderId: parseFloat(this.$route.query.id),
        amount: parseFloat(this.orderDetails.amount),     
        paymentMode: "BranchWallet",
      };
      $(".loader").show();
      this.isButtonDisabled = true;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Industrial/OrderPayment`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.status = this.success;
          this.showModal();
          this.$toast.open({
            message: this.$t('text.iAddOrder.paymentConfirmed'),
            type: "success",
            duration: 3000
          });
          this.$refs.paymentStep.classList.add('active_outer_circle');
          this.$refs.payment_inner_step.classList.add('active_inner');
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch(error => {
           this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000
          });
          this.status = this.failure;
          this.showModal();
          $(".loader").hide();
          this.isButtonDisabled = false;
        });
    },
    confirmPayment() {
      let paymentMode;
      if(this.tab === 'wallet') {
        paymentMode = 'Branchallet'
      }else {
        paymentMode = 'rave';
      }
      let data = {
        "orderId": parseInt(this.$route.query.id),
        "amount": parseFloat(this.totalAmount),       
        "paymentMode": paymentMode,
        "trx_Ref": this.trxRef,
        "flw": true,
        "flwRef": this.flwRef,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Industrial/OrderPayment`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.status = this.success;
          this.showModal();
          this.$toast.open({
            message: this.$t('text.iAddOrder.paymentConfirmed'),
            type: "success",
            duration: 3000
          });
          this.$refs.paymentStep.classList.add('active_outer_circle');
          this.$refs.payment_inner_step.classList.add('active_inner');
        })
        .catch(error => {
          this.status = this.failure;
        });
    },
    getFundProperties() {
      this.showBtnLoader = true;
      if (localStorage.getItem("userDetails")) {
        let url =  `${configObject.apiBaseUrl}/Wallet/FundProperties`;
        this.axios
          .get(url, configObject.authConfig())
          .then(response => {
            let user = JSON.parse(localStorage.getItem("userDetails"));
            this.showBtnLoader = false;
            this.email = user.email;
            this.phone = user.phone;
            this.publicKey = response.data.publicKey;
            this.banks = response.data.banks;
          })
          .catch(error => {});
      }
    },
    payFunction(event) {
      event.preventDefault();
      $(".email").val(this.email);
      $(".phone").val(this.phone);
      $(".publicKey").val(this.publicKey);
      var btn = $(this);
      btn.attr("disabled", "disabled");
      var realAmt = parseFloat($(".amount").val());
      if (isFinite(realAmt) && realAmt > 0) {
        //var amt = realAmt + (realAmt * (1.6 / 100));

        var email = $(".email").val();
        var phone = $(".phone").val();
        var pk = $(".publicKey").val(); //"FLWPUBK-fc08788826e348423d0d89eb1370f784-X";//
        var allString = "0123456789";
        var PBFKey = pk;
        var rString = "EP" + this.randomString(14, allString);
        let _this = this;
        // eslint-disable-next-line no-undef
        let raveSetup = getpaidSetup({
          PBFPubKey: PBFKey,
          customer_email: email,
          customer_firstname: "",
          customer_lastname: "",
          custom_description: "Diesel/LPG Order Payment",
          custom_logo:
            "https://app.epump.com.ng/Content_v3/Images/e-pump%20logo2.png",
          custom_title: "EPUMP",
          amount: realAmt,
          customer_phone: phone,
          country: "NG",
          currency: "NGN",
          payment_method: "both",
          txref: rString,
          //integrity_hash: "<ADD YOUR INTEGRITY HASH HERE>",

         callback: function(response) {
            var flw_ref = response.data.transactionobject.flwRef; // collect flwRef returned and pass to a erver page to complete status check.
            
            if (
              response.data.respcode == "00" 
            ) {
              _this.trxRef = response.data.transactionobject.txRef;
              _this.flwRef = flw_ref;
              _this.amount = realAmt.toString();
              //_this.closeModal();
              _this.confirmPayment();
              // $('.trxRef').val(response.tx.txRef);
              // $('.flwRef').val(flw_ref);
              //$('.onlinePay').submit();

              // redirect to a success page
            } else {
              // redirect to a failure page.
            }
            raveSetup.close();
          },
          onclose: function() {
            btn.removeAttr("disabled");
          }
        });
      } else {
        this.$toast.open({
          message: this.$t('text.iAddOrder.amountMissing'),
          type: "error",
          duration: 10000
        });
        btn.removeAttr("disabled");
      }
    },
    changeProgrestatus(viewStatus, from) {
        if(viewStatus === 'order') {
            this.$refs.shipping_step.classList.remove('active_outer_circle');
            this.$refs.shipping_inner_step.classList.remove('active_inner');

            this.$refs.paymentStep.classList.remove('active_outer_circle');
            this.$refs.payment_inner_step.classList.remove('active_inner');

        }
        if(viewStatus === 'shipping') {
            let pricePerLiter = parseFloat(this.pricePerLiter);
            this.formattedAmount = this.convertThousand(pricePerLiter * this.volume);
            this.$refs.shipping_step.classList.add('active_outer_circle');
            this.$refs.shipping_inner_step.classList.add('active_inner');

            this.$refs.paymentStep.classList.remove('active_outer_circle');
            this.$refs.payment_inner_step.classList.remove('active_inner');
        }
         if(viewStatus === 'payment') {
          
          // this.$refs.paymentStep.classList.add('active_outer_circle');
          // this.$refs.payment_inner_step.classList.add('active_inner');
        }
        
        this.viewStatus = viewStatus;
    },
 }
};
</script>
